const r2 = (v) => Number.parseFloat((Number(v) || 0).toFixed(2));
const r3 = (v) => Number.parseFloat((Number(v) || 0).toFixed(3));
const txt = (v) => String(v || '').trim().toLowerCase();

function itemsPromo(promo) {
  if (Array.isArray(promo.items)) return promo.items.filter(Boolean);
  try { const p = JSON.parse(promo.items || '[]'); return Array.isArray(p) ? p.filter(Boolean) : []; } catch { return []; }
}

function activaAhora(promo, fecha = new Date()) {
  if (promo.activo === false) return false;
  const hoy = fecha.toISOString().slice(0, 10);
  if (promo.fecha_inicio && String(promo.fecha_inicio).slice(0, 10) > hoy) return false;
  if (promo.fecha_fin && String(promo.fecha_fin).slice(0, 10) < hoy) return false;
  const dias = Array.isArray(promo.dias_semana) ? promo.dias_semana.map(Number) : [];
  if (dias.length && !dias.includes(fecha.getDay())) return false;
  if (promo.hora_inicio && promo.hora_fin) {
    const hhmm = fecha.toTimeString().slice(0, 5);
    const inicio = String(promo.hora_inicio).slice(0, 5);
    const fin = String(promo.hora_fin).slice(0, 5);
    const dentro = inicio <= fin ? hhmm >= inicio && hhmm <= fin : hhmm >= inicio || hhmm <= fin;
    if (!dentro) return false;
  }
  return true;
}

function coincide(item, regla) {
  if (regla.producto_id != null && Number(regla.producto_id) === Number(item.id)) return true;
  if (regla.categoria && txt(regla.categoria) === txt(item.categoria)) return true;
  if (regla.marca && txt(regla.marca) === txt(item.marca)) return true;
  return false;
}
function combinable(item, promo) {
  if (!item.promociones_aplicadas.length) return true;
  return Boolean(promo.acumulable) && item.promociones_aplicadas.every((p) => Boolean(p.acumulable));
}
function registrar(item, promo, descuento, limitado = false) {
  const monto = r2(descuento);
  if (monto <= 0) return;
  item.descuento_aplicado = r2(item.descuento_aplicado + monto);
  item.subtotal_final = r2(Math.max(0, item.subtotal_final - monto));
  item.precio_final = item.cantidad > 0 ? r2(item.subtotal_final / item.cantidad) : 0;
  item.promociones_aplicadas.push({ id: Number(promo.id), nombre: promo.nombre, tipo: promo.tipo, descuento: monto, acumulable: Boolean(promo.acumulable), limitado_margen: limitado });
  item.promocion_id ||= Number(promo.id);
  item.promocion_nombre = item.promociones_aplicadas.map((p) => p.nombre).join(' + ');
}
function conMargen(item, promo, solicitado) {
  const margen = Math.max(0, Number(promo.margen_minimo_porcentaje || 0));
  const costo = Math.max(0, Number(item.costo || item.precio_costo || 0));
  const minimo = r2(costo * (1 + margen / 100) * item.cantidad);
  const disponible = r2(Math.max(0, item.subtotal_final - minimo));
  const desc = r2(Math.min(Math.max(0, solicitado), disponible, item.subtotal_final));
  registrar(item, promo, desc, desc + 0.009 < solicitado);
}

function aplicarDirecto(carrito, promo) {
  for (const item of carrito) {
    if (!combinable(item, promo)) continue;
    const reglas = promo.items.filter((r) => coincide(item, r));
    if (!reglas.length) continue;
    const min = Math.max(0.001, ...reglas.map((r) => Number(r.cantidad_minima || 1)));
    if (item.cantidad + 0.0001 < min) continue;
    const pct = Math.max(0, Number(promo.descuento_porcentaje || 0));
    const unit = Math.max(0, Number(promo.descuento_monto || 0));
    conMargen(item, promo, pct > 0 ? item.subtotal_final * pct / 100 : unit * item.cantidad);
  }
}
function aplicarNxM(carrito, promo) {
  const lleva = Math.max(1, Number(promo.cantidad_lleva || (promo.tipo === '2x1' ? 2 : 0)));
  const paga = Math.max(0, Math.min(lleva, Number(promo.cantidad_paga || (promo.tipo === '2x1' ? 1 : 0))));
  if (paga >= lleva) return;
  for (const item of carrito) {
    if (!combinable(item, promo) || !promo.items.some((r) => coincide(item, r))) continue;
    const grupos = Math.floor(item.cantidad / lleva);
    if (grupos > 0) conMargen(item, promo, grupos * (lleva - paga) * (item.subtotal_final / item.cantidad));
  }
}
function aplicarSegunda(carrito, promo) {
  const pct = Math.max(0, Math.min(100, Number(promo.porcentaje_segunda || promo.descuento_porcentaje || 0)));
  for (const item of carrito) {
    if (!combinable(item, promo) || item.cantidad < 2 || !promo.items.some((r) => coincide(item, r))) continue;
    conMargen(item, promo, Math.floor(item.cantidad / 2) * (item.subtotal_final / item.cantidad) * pct / 100);
  }
}
function aplicarCombo(carrito, promo) {
  const reglas = promo.items.filter((r) => r.producto_id != null);
  if (!reglas.length) return;
  let combos = Infinity; const encontrados = [];
  for (const regla of reglas) {
    const item = carrito.find((i) => Number(i.id) === Number(regla.producto_id));
    const requerida = Math.max(0.001, Number(regla.cantidad_minima || 1));
    if (!item || !combinable(item, promo) || item.cantidad + 0.0001 < requerida) return;
    combos = Math.min(combos, Math.floor(item.cantidad / requerida)); encontrados.push({ item, requerida });
  }
  if (!Number.isFinite(combos) || combos <= 0) return;
  const actual = encontrados.reduce((s, x) => s + (x.item.subtotal_final / x.item.cantidad) * x.requerida, 0);
  const totalDesc = r2(Math.max(0, (actual - Math.max(0, Number(promo.precio_combo || 0))) * combos));
  if (totalDesc <= 0 || actual <= 0) return;
  for (const x of encontrados) conMargen(x.item, promo, totalDesc * (((x.item.subtotal_final / x.item.cantidad) * x.requerida) / actual));
}

export function calcularPromocionesOffline(carrito, promociones = []) {
  const procesado = (carrito || []).filter((x) => !x.es_manual).map((item) => {
    const precio = Math.max(0, Number(item.precio_venta || item.precio_unitario || item.precio || 0));
    const cantidad = Math.max(0, Number(item.cantidad || 0));
    const subtotal = r2(precio * cantidad);
    return { ...item, precio_original: precio, cantidad: r3(cantidad), descuento_aplicado: 0, promocion_id: null, promocion_nombre: null, promociones_aplicadas: [], precio_final: precio, subtotal_original: subtotal, subtotal_final: subtotal };
  });
  const activas = (promociones || []).filter((p) => activaAhora(p)).map((p) => ({ ...p, items: itemsPromo(p) })).sort((a, b) => Number(b.prioridad || 0) - Number(a.prioridad || 0) || Number(a.id) - Number(b.id));
  for (const promo of activas) {
    if (['descuento_producto','descuento_categoria','descuento_marca'].includes(promo.tipo)) aplicarDirecto(procesado, promo);
    else if (promo.tipo === '2x1' || promo.tipo === 'nxm') aplicarNxM(procesado, promo);
    else if (promo.tipo === 'segunda_unidad') aplicarSegunda(procesado, promo);
    else if (promo.tipo === 'combo_fijo') aplicarCombo(procesado, promo);
  }
  const manuales = (carrito || []).filter((x) => x.es_manual).map((item) => {
    const precio = Number(item.precio_venta || 0), cantidad = Number(item.cantidad || 0), subtotal = r2(precio * cantidad);
    return { ...item, id: item.id, descripcion: item.descripcion, precio_original: precio, precio_final: precio, cantidad, subtotal_original: subtotal, subtotal_final: subtotal, descuento_aplicado: 0, promociones_aplicadas: [] };
  });
  const items = [...procesado, ...manuales];
  const subtotal_original = r2(items.reduce((s, i) => s + Number(i.subtotal_original || 0), 0));
  const descuento_total = r2(items.reduce((s, i) => s + Number(i.descuento_aplicado || 0), 0));
  return { items, subtotal_original, descuento_total, total_final: r2(subtotal_original - descuento_total), ahorro_total: descuento_total, modo_offline: true };
}
